export enum BiEventType {
	UserAction = 'UserActionType',
	SessionStart = 'SessionStartType',
	StageReport = 'StageReportType'
}

export enum BiAction {
	Clicked = 'click',
	Select = 'select',
	Toggle = 'toggle',
	Update = 'update'
}

export enum BiLocationObject {
	RxContainer = 'Rx'
}

export enum BiObjectType {
	Button = 'button',
	ToggleButton = 'toggleButton',
	CheckBox = 'checkBox',
	RadioButton = 'radioButton',
	DropdownList = 'dropdownList',
	Switch = 'switch'
}

export enum BiBannerType {
	BannerRegister = 'banner-Register',
	BannerLearnMore = 'banner-LearnMore'
}

export enum BiObjectName {
	MultiBiteRestoScan = 'multiBiteRestoScan',
	IsDraft = 'attachmentOnHold',
	PalatalScanningFeedback = 'Palate Scanning Feedback Toggle',
	ApplianceOptions = 'ApplianceOptions_Type',
	ApplianceOptionsArch = 'ApplianceOptions_Arch',
	DentureOptionsArch = 'DentureOptions_Arch',
	ToothDiagram = 'Tooth_Diagram',
	OrderType = 'Order_Type',
	RxModeSelector = 'rxModeSelector'
}

export enum BiObject {
	Attachments = 'RXForm_Attachments',
	ScanOptions = 'RXForm_ScanOptions'
}

export enum BiStage {
	Save = 'save'
}
